'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import type { MediaRelease } from '@/app/admin/media-releases/page';

const STORAGE_KEY = 'wto_media_releases_v2';

const defaultReleases: MediaRelease[] = [
{
  id: 'mr-1',
  title: 'The Story in Kilometers: The Nikolov Family and World Transport Overseas',
  source: 'Magazine Capital',
  excerpt: 'Capital newspaper tells the story of the Nikolov family and how they built World Transport Overseas into one of the fastest-growing logistics companies in Eastern Europe.',
  href: 'https://www.capital.bg/biznes/kompanii/2024/07/15/4800707_vlastelinite_na_logistikata_semeistvo_nikolovi_i/',
  image: "/assets/images/remote/rocket-gen-img-12fbf9543-1767689971956.png",
  alt: 'Nikolov family and World Transport Overseas story in Capital magazine',
  tag: 'Awards',
  date: '2024-07-15',
  featured: true
},
{
  id: 'mr-2',
  title: 'Captain of the Logistics Revolution!',
  source: 'Forbes',
  excerpt: 'Forbes Bulgaria profiles Nikolay Nikolov, CEO of World Transport Overseas, as a captain of the logistics revolution driving the company\'s global expansion.',
  href: 'https://forbesbulgaria.com/2025/07/04/nikolaj-nikolov-kapitan-na-logistichnata-revolyutsiya/',
  image: "/assets/images/remote/rocket-gen-img-12ed3d030-1763292004069.png",
  alt: 'Forbes Bulgaria article on Nikolay Nikolov captain of logistics revolution',
  tag: 'Awards',
  date: '2025-07-04',
  featured: false
},
{
  id: 'mr-3',
  title: 'Entrepreneur of the Year 2024',
  source: 'Forbes Magazine',
  excerpt: 'For the first time, two people were named Entrepreneur of the Year at the Forbes DNA of Success Awards 2024 — World Transport Overseas among the honorees.',
  href: 'https://forbesbulgaria.com/2024/10/10/za-prav-pat-dvama-dushi-stanaha-predpriemach-na-godinata-po-vreme-na-forbes-dna-of-success-awards-2024/',
  image: "/assets/images/remote/rocket-gen-img-1e2e140ec-1776676673070.png",
  alt: 'Forbes Entrepreneur of the Year 2024 award ceremony',
  tag: 'Awards',
  date: '2024-10-10',
  featured: false
},
{
  id: 'mr-4',
  title: 'The new stars of the Forbes Business Awards! World Transport is among them!',
  source: 'Forbes Magazine',
  excerpt: 'Forbes Business Awards 2024 announces its winners — World Transport Overseas is among the new stars recognized for outstanding business performance.',
  href: 'https://forbesbulgaria.com/2024/04/18/novite-zvezdi-na-forbes-business-awards-vizhte-pobeditelite/',
  image: "/assets/images/remote/rocket-gen-img-1399826a5-1776676673848.png",
  alt: 'Forbes Business Awards 2024 winners announcement featuring World Transport Overseas',
  tag: 'Awards',
  date: '2024-04-18',
  featured: false
},
{
  id: 'mr-5',
  title: 'Expansiunea în America de Nord, următoarea țintă a World Transport Overseas',
  source: 'Intermodal and Logistics',
  excerpt: 'Romanian logistics magazine Intermodal and Logistics covers World Transport Overseas\'s expansion into North America as the company\'s next major strategic target.',
  href: 'https://www.intermodal-logistics.ro/expansiunea-in-america-de-nord-urmatoarea-tinta-a-world-transport-overseas',
  image: "/assets/images/remote/rocket-gen-img-1f357c997-1767001282504.png",
  alt: 'World Transport Overseas North America expansion article in Intermodal and Logistics magazine',
  tag: 'Expansion',
  date: '2024-01-01',
  featured: false
},
{
  id: 'mr-6',
  title: 'Nikolay Nikolov is in the Winners\' Team for Manager of the Year 2023!',
  source: 'Manager of the Year 2023',
  excerpt: 'Nikolay Nikolov, CEO of World Transport Overseas, is named among the finalists and winners of the prestigious Manager of the Year 2023 competition in Bulgaria.',
  href: 'https://manager.bg/bylgariya/otborat-na-pobeditelite-finalistite-v-menidzar-na-godinata-2023-veche-sa-izvestni-',
  image: "/assets/images/remote/rocket-gen-img-166eebdce-1776676673301.png",
  alt: 'Nikolay Nikolov Manager of the Year 2023 award winners team',
  tag: 'Awards',
  date: '2023-01-01',
  featured: false
},
{
  id: 'mr-7',
  title: 'Interviu WTO: România, tot mai interesantă pentru afacerile regionale',
  source: 'Logistics Post',
  excerpt: 'Romanian logistics publication Logistics Post interviews World Transport Overseas about Romania\'s growing importance as a regional business hub for the company.',
  href: 'https://logisticpost.ro/articole/interviu-wto-romania-tot-mai-interesanta-pentru-afacerile-regionale.html',
  image: "/assets/images/remote/rocket-gen-img-10c53ff9b-1776676672789.png",
  alt: 'Logistics Post interview with World Transport Overseas about Romania regional business',
  tag: 'Industry News',
  date: '2023-06-01',
  featured: false
},
{
  id: 'mr-8',
  title: 'Bogdan Gavrilović, Managing Director, World Transport Overseas — Next Major Step: America',
  source: 'CorD Magazine',
  excerpt: 'CorD Magazine interviews Bogdan Gavrilović, Managing Director of World Transport Overseas Serbia, about the company\'s next major strategic step: expansion into America.',
  href: 'https://cordmagazine.com/business/success-stories/bogdan-gavrilovic-world-transport-overseas-next-major-step-america/',
  image: "/assets/images/remote/rocket-gen-img-1740b125c-1776676672117.png",
  alt: 'CorD Magazine interview with Bogdan Gavrilovic WTO Managing Director about America expansion',
  tag: 'Expansion',
  date: '2023-09-01',
  featured: false
},
{
  id: 'mr-9',
  title: 'Interview with Maria Georgiou, MD of WTO Hellas: "2023 so far better than predicted"',
  source: 'Container News',
  excerpt: 'Container News interviews Maria Georgiou, Managing Director of WTO Hellas, about the company\'s performance, the Greek shipping market, and WTO\'s vision for expansion.',
  href: 'https://container-news.com/interview-with-maria-georgiou-md-of-wto-hellas-2023-so-far-better-than-predicted/',
  image: "/assets/images/remote/photo-1671584643604-c138df6ea4a8.jpg",
  alt: 'Container News interview with Maria Georgiou MD of WTO Hellas about 2023 performance',
  tag: 'Industry News',
  date: '2023-08-01',
  featured: false
},
{
  id: 'mr-10',
  title: 'Топ мениджърите на България 2020: Николай Николов, управител на „Уърлд транспорт Оувърсийз България"',
  source: 'сп. Мениджър',
  excerpt: 'Manager magazine features Nikolay Nikolov, CEO of World Transport Overseas Bulgaria, in its Top Managers of Bulgaria 2020 special edition.',
  href: 'https://www.manager.bg/menidzhmnt/top-menidzhrite-na-blgariya-2020-nikolay-nikolov-upravitel-na-urld-transport-ouvrsiyz',
  image: "/assets/images/remote/rocket-gen-img-1b90ee5bf-1776676672568.png",
  alt: 'Manager magazine Top Managers of Bulgaria 2020 featuring Nikolay Nikolov of World Transport Overseas',
  tag: 'Awards',
  date: '2020-01-01',
  featured: false
},
{
  id: 'mr-11',
  title: 'Уърлд Транспорт Оувърсийз откри представителство в Гърция!',
  source: 'сп. Логистика',
  excerpt: 'Bulgarian logistics magazine covers World Transport Overseas opening its own representative office in Greece, marking a significant step in the company\'s regional expansion.',
  href: 'https://www.logistika.bg/bg/menu/256/post/28139/Uyrld-Transport-Ouvyrsijz-otkri-predstavitelstvo-v-Gyrciq',
  image: "/assets/images/remote/rocket-gen-img-134bba0a3-1767521875860.png",
  alt: 'Logistics magazine article about World Transport Overseas opening office in Greece',
  tag: 'Expansion',
  date: '2022-01-01',
  featured: false
},
{
  id: 'mr-12',
  title: 'Победители с мисия: Уърлд Транспорт Оувърсийз',
  source: 'сп. Forbes',
  excerpt: 'Forbes Bulgaria features World Transport Overseas as "Winners with a Mission" following the company\'s recognition as Company of the Year 2020 in the Services sector.',
  href: 'https://forbesbulgaria.com/2020/10/26/pobeditelite-s-misiya-uyrld-transport-ouvrsiyz/',
  image: "/assets/images/remote/rocket-gen-img-17fbb2da5-1775648524339.png",
  alt: 'Forbes Bulgaria article on World Transport Overseas as winners with a mission',
  tag: 'Awards',
  date: '2020-10-26',
  featured: false
},
{
  id: 'mr-13',
  title: 'Мениджър на годината 2020',
  source: 'сп. Мениджър',
  excerpt: 'Manager magazine covers the Manager of the Year 2020 competition, featuring World Transport Overseas leadership among the recognized top managers in Bulgaria.',
  href: 'https://youtu.be/-BiHZGq-VL0',
  image: "/assets/images/remote/rocket-gen-img-133309bca-1776676673195.png",
  alt: 'Manager of the Year 2020 award video featuring World Transport Overseas',
  tag: 'Awards',
  date: '2020-01-01',
  featured: false
},
{
  id: 'mr-14',
  title: 'Да растеш в хаоса',
  source: 'сп. Forbes',
  excerpt: 'Forbes Bulgaria publishes an in-depth article on how World Transport Overseas grew and thrived during the chaos of the global pandemic, maintaining operations across all markets.',
  href: 'https://forbesbulgaria.com/2021/03/09/kak-da-rastesh-v-haosa/',
  image: "/assets/images/remote/rocket-gen-img-1144d434c-1770196801141.png",
  alt: 'Forbes Bulgaria article on World Transport Overseas growing during chaos of pandemic',
  tag: 'Industry News',
  date: '2021-03-09',
  featured: false
},
{
  id: 'mr-15',
  title: 'WTO started building a new logistics center',
  source: 'Logistics Magazine',
  excerpt: 'Logistics Magazine reports on World Transport Overseas breaking ground on a new modern logistics center near Sofia Airport, a key milestone in the company\'s infrastructure investment.',
  href: 'https://www.logistika.bg/bg/menu/23/post/23360/WTO-zapochna-stroitelstvoto-na-logistichen-centyr',
  image: "/assets/images/remote/rocket-gen-img-191f8a49e-1776676671492.png",
  alt: 'World Transport Overseas new logistics center construction near Sofia Airport',
  tag: 'Expansion',
  date: '2019-01-01',
  featured: false
},
{
  id: 'mr-16',
  title: '"Regional presence gives our company an advantage"',
  source: 'Logistics Magazine',
  excerpt: 'Logistics Magazine interviews World Transport Overseas management about how the company\'s strong regional presence across the Balkans gives it a competitive advantage in the market.',
  href: 'https://www.logistika.bg/bg/menu/23/post/21207/Regionalnoto-prisystvie-dava-predimstvo-na-kompaniqta-ni',
  image: "/assets/images/remote/rocket-gen-img-197aa35b1-1769227046797.png",
  alt: 'Logistics Magazine interview about World Transport Overseas regional presence advantage',
  tag: 'Industry News',
  date: '2018-01-01',
  featured: false
},
{
  id: 'mr-17',
  title: 'WTO - launched a new direct, weekly service to Israel',
  source: 'Logistics Magazine',
  excerpt: 'Logistics Magazine covers World Transport Overseas Bulgaria launching a new direct weekly sea freight service to Israel, expanding its Mediterranean trade lane coverage.',
  href: 'https://www.logistika.bg/bg/menu/23/post/19309/WTO-s-nov-direkten-sedmichen-serviz-do-Izrael',
  image: "/assets/images/remote/rocket-gen-img-1517d0d68-1776676671499.png",
  alt: 'World Transport Overseas new direct weekly service to Israel announcement',
  tag: 'Services',
  date: '2017-01-01',
  featured: false
},
{
  id: 'mr-18',
  title: 'Conquering new horizons by sea and air – Forbes Business AWARDS',
  source: 'Forbes Bulgaria',
  excerpt: 'Forbes Bulgaria covers World Transport Overseas conquering new horizons in sea and air freight, recognized at the prestigious Forbes Business Awards for outstanding performance.',
  href: 'https://forbesbulgaria.bg/2016/11/08/prevzemane-na-novi-horizonti-po-more-i-vazduh-forbes-business-awards/',
  image: "/assets/images/remote/rocket-gen-img-196257bfe-1764657836244.png",
  alt: 'Forbes Business Awards article on World Transport Overseas conquering new horizons by sea and air',
  tag: 'Awards',
  date: '2016-11-08',
  featured: false
}];


const tagColors: Record<string, {bg: string;text: string;border: string;}> = {
  'Awards': { bg: 'rgba(245,158,11,0.15)', text: '#D97706', border: 'rgba(245,158,11,0.3)' },
  'Services': { bg: 'rgba(27,107,138,0.15)', text: '#2A8FAB', border: 'rgba(27,107,138,0.3)' },
  'Expansion': { bg: 'rgba(16,185,129,0.15)', text: '#059669', border: 'rgba(16,185,129,0.3)' },
  'Partnerships': { bg: 'rgba(99,102,241,0.15)', text: '#818CF8', border: 'rgba(99,102,241,0.3)' },
  'Industry News': { bg: 'rgba(100,116,139,0.15)', text: '#94A3B8', border: 'rgba(100,116,139,0.3)' },
  'Sustainability': { bg: 'rgba(34,197,94,0.15)', text: '#22C55E', border: 'rgba(34,197,94,0.3)' },
  'Technology': { bg: 'rgba(168,85,247,0.15)', text: '#A855F7', border: 'rgba(168,85,247,0.3)' }
};

function getTagStyle(tag: string) {
  return tagColors[tag] ?? { bg: 'rgba(100,116,139,0.15)', text: '#94A3B8', border: 'rgba(100,116,139,0.3)' };
}

function formatDate(dateStr: string) {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return dateStr;
  }
}

// Source icon — shows a newspaper SVG or the article image
function ArticleMedia({ image, alt, source }: {image: string;alt: string;source: string;}) {
  const initials = source.
  split(' ').
  slice(0, 2).
  map((w) => w[0]).
  join('').
  toUpperCase();

  if (image) {
    return (
      <div className="w-full h-full">
        <img src={image} alt={alt} className="w-full h-full object-cover" />
      </div>);

  }

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[#0f2340] to-[#0a1628]">
      <svg className="w-8 h-8 text-[#2A8FAB]/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
      </svg>
      <span className="text-[#2A8FAB]/60 text-xs font-bold tracking-widest">{initials}</span>
    </div>);

}

export default function MediaReleasesPage() {
  const [releases, setReleases] = useState<MediaRelease[]>([]);
  const [activeTag, setActiveTag] = useState('All');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      setReleases(stored ? JSON.parse(stored) : defaultReleases);
    } catch {
      setReleases(defaultReleases);
    }
  }, []);

  const allTags = ['All', ...Array.from(new Set(releases.map((r) => r.tag).filter(Boolean)))];
  const filtered = activeTag === 'All' ? releases : releases.filter((r) => r.tag === activeTag);
  const featured = filtered.find((r) => r.featured) ?? filtered[0];
  const rest = filtered.filter((r) => r.id !== featured?.id);

  if (!mounted) return null;

  return (
    <div style={{ fontFamily: 'DM Sans, sans-serif' }} className="min-h-screen bg-[#060e1e] text-white">
      <Header />

      {/* Page Hero */}
      <section className="relative bg-[#060e1e] pt-28 pb-14 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#2A8FAB]/6 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-[#0f2340]/80 rounded-full blur-2xl" />
        </div>
        <div className="relative max-w-6xl mx-auto px-6">
          <div className="flex items-center gap-2 text-sm text-gray-500 mb-5">
            <Link href="/" className="hover:text-[#2A8FAB] transition-colors">Home</Link>
            <span>/</span>
            <span className="text-gray-300">Media Releases</span>
          </div>
          <div className="flex items-end justify-between gap-6 flex-wrap">
            <div>
              <p className="text-[#2A8FAB] text-sm font-semibold uppercase tracking-widest mb-3">Press &amp; Media</p>
              <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight">
                Media Releases
              </h1>
              <p className="text-gray-400 mt-3 max-w-xl text-base leading-relaxed">
                News and articles about World Transport Overseas from media outlets and industry publications around the world.
              </p>
            </div>
            <Link
              href="/admin/media-releases"
              className="flex items-center gap-2 border border-[#1e3a5f] hover:border-[#2A8FAB]/60 text-gray-400 hover:text-white px-4 py-2.5 rounded-xl text-sm transition-all">
              
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c-.94 1.543-.826 3.31 2.37 2.37a1.724 1.724 0 002.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Manage Articles
            </Link>
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      {allTags.length > 1 &&
      <section className="border-b border-[#1e3a5f]/60 bg-[#060e1e] sticky top-0 z-10">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex items-center gap-1 overflow-x-auto py-3 scrollbar-hide">
              {allTags.map((tag) =>
            <button
              key={tag}
              onClick={() => setActiveTag(tag)}
              className={`flex-shrink-0 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              activeTag === tag ?
              'bg-[#2A8FAB] text-white' :
              'text-gray-400 hover:text-white hover:bg-white/5'}`
              }>
              
                  {tag}
                </button>
            )}
            </div>
          </div>
        </section>
      }

      <main className="max-w-6xl mx-auto px-6 py-12">
        {releases.length === 0 ?
        <div className="text-center py-24 text-gray-500">
            <svg className="w-14 h-14 mx-auto mb-4 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
            </svg>
            <p className="text-lg">No media articles yet.</p>
            <Link href="/admin/media-releases" className="text-[#2A8FAB] hover:underline text-sm mt-2 inline-block">Add the first article →</Link>
          </div> :
        filtered.length === 0 ?
        <div className="text-center py-24 text-gray-500">
            <p>No articles in this category.</p>
          </div> :

        <>
            {/* Featured Article */}
            {featured &&
          <div className="mb-10">
                <div className="bg-[#0a1628] border border-[#1e3a5f] rounded-2xl overflow-hidden flex flex-col md:flex-row hover:border-[#2A8FAB]/40 transition-all group">
                  {/* Image */}
                  <div className="md:w-2/5 h-56 md:h-auto flex-shrink-0 relative overflow-hidden">
                    <ArticleMedia image={featured.image} alt={featured.alt} source={featured.source} />
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0a1628]/20 md:block hidden" />
                  </div>
                  {/* Content */}
                  <div className="flex-1 p-7 flex flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-3 mb-4 flex-wrap">
                        <span className="text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full border"
                    style={{ background: getTagStyle(featured.tag).bg, color: getTagStyle(featured.tag).text, borderColor: getTagStyle(featured.tag).border }}>
                          {featured.tag}
                        </span>
                        <span className="flex items-center gap-1.5 text-sm text-gray-400 font-medium">
                          <svg className="w-3.5 h-3.5 text-[#2A8FAB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 00-2 2V6a2 2 0 002-2h10a2 2 0 002 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                          </svg>
                          {featured.source}
                        </span>
                        {featured.date &&
                    <span className="text-xs text-gray-500">{formatDate(featured.date)}</span>
                    }
                      </div>
                      <h2 className="text-xl md:text-2xl font-bold text-white leading-snug mb-3 group-hover:text-[#2A8FAB] transition-colors">
                        {featured.title}
                      </h2>
                      {featured.excerpt &&
                  <p className="text-gray-400 text-sm leading-relaxed line-clamp-3">{featured.excerpt}</p>
                  }
                    </div>
                    <div className="mt-6">
                      <a
                    href={featured.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-[#2A8FAB] hover:bg-[#1e7a94] text-white font-semibold px-6 py-3 rounded-xl transition-all text-sm">
                    
                        Read Article
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
          }

            {/* Article Grid */}
            {rest.length > 0 &&
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {rest.map((release) =>
            <article
              key={release.id}
              className="bg-[#0a1628] border border-[#1e3a5f] rounded-2xl overflow-hidden flex flex-col hover:border-[#2A8FAB]/40 transition-all group">
              
                    {/* Thumbnail */}
                    <div className="h-44 flex-shrink-0 overflow-hidden relative">
                      <ArticleMedia image={release.image} alt={release.alt} source={release.source} />
                    </div>

                    {/* Body */}
                    <div className="flex flex-col flex-1 p-5">
                      {/* Meta */}
                      <div className="flex items-center gap-2 mb-3 flex-wrap">
                        <span
                    className="text-xs font-semibold px-2.5 py-0.5 rounded-full border"
                    style={{ background: getTagStyle(release.tag).bg, color: getTagStyle(release.tag).text, borderColor: getTagStyle(release.tag).border }}>
                    
                          {release.tag}
                        </span>
                        <span className="text-xs text-gray-500 font-medium">{release.source}</span>
                      </div>

                      {/* Title */}
                      <h3 className="text-white font-bold text-sm leading-snug mb-2 line-clamp-3 group-hover:text-[#2A8FAB] transition-colors flex-1">
                        {release.title}
                      </h3>

                      {/* Excerpt */}
                      {release.excerpt &&
                <p className="text-gray-500 text-xs leading-relaxed line-clamp-2 mb-4">{release.excerpt}</p>
                }

                      {/* Footer */}
                      <div className="flex items-center justify-between mt-auto pt-4 border-t border-[#1e3a5f]/60">
                        {release.date ?
                  <span className="text-xs text-gray-600">{formatDate(release.date)}</span> :
                  <span />}
                        <a
                    href={release.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 bg-[#2A8FAB]/10 hover:bg-[#2A8FAB] border border-[#2A8FAB]/30 hover:border-[#2A8FAB] text-[#2A8FAB] hover:text-white font-semibold px-4 py-2 rounded-lg transition-all text-xs">
                    
                          Read Article
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </article>
            )}
              </div>
          }
          </>
        }
      </main>

      <Footer />
    </div>);

}